import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import GlobalToaster from "./components/common/GlobalToaster";
import { AdminAuthProvider } from "./context/AdminAuthContext.js";
import { AuthProvider } from "./context/AuthContext.js";
import { CartProvider } from "./context/CartContext";
import {
  adminNonAuthRoutes,
  adminRoutes,
  staffRoutes,
  userNonAuthRoutes,
  userRoutes,
} from "./routes/AllRoutes";
import AdminNonAuthLayout from "./routes/middleware/AdminNonAuthLayout.jsx";
import AdminNonAuthRoute from "./routes/middleware/AdminNonAuthRoute.jsx";
import AdminProtectedRoute from "./routes/middleware/AdminProtectedRoute.jsx";
import UserLayout from "./routes/middleware/UserLayout";
import UserNonAuthLayout from "./routes/middleware/UserNonAuthLayout.jsx";
import UserProtectedRoute from "./routes/middleware/UserProtectedRoute.jsx";
import GetAdminLayout from "./utils/getAdminLayout.js";
import { PackageBookingProvider } from "./context/PackageBookingContext.js";
import { NotificationProvider } from "./context/NotificationContext.js";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 120,
    });
  }, []);

  return (
    <React.Fragment>
      <BrowserRouter>
        <AuthProvider>
          <AdminAuthProvider>
            <NotificationProvider>
              <CartProvider>
                <PackageBookingProvider>
                  <Routes>
                    {/*  USER PUBLIC (NO AUTH CHECK) */}
                    {userRoutes
                      .filter((r) => !r.protected)
                      .map((r, i) => (
                        <Route
                          key={i}
                          path={r.path}
                          element={<UserLayout>{r.component}</UserLayout>}
                        />
                      ))}

                    {/*  USER PROTECTED */}
                    {userRoutes
                      .filter((r) => r.protected)
                      .map((r, i) => (
                        <Route
                          key={i}
                          path={r.path}
                          element={
                            <UserProtectedRoute>
                              <UserLayout>{r.component}</UserLayout>
                            </UserProtectedRoute>
                          }
                        />
                      ))}

                    {/*  USER NON-AUTH (login / register) */}
                    {userNonAuthRoutes.map((r, i) => (
                      <Route
                        key={i}
                        path={r.path}
                        element={
                          <UserNonAuthLayout>
                            <UserNonAuthLayout>{r.component}</UserNonAuthLayout>
                          </UserNonAuthLayout>
                        }
                      />
                    ))}

                    {/*  ADMIN NON-AUTH */}
                    {adminNonAuthRoutes.map((r, i) => (
                      <Route
                        key={i}
                        path={r.path}
                        element={
                          <AdminNonAuthRoute>
                            <AdminNonAuthLayout>{r.component}</AdminNonAuthLayout>
                          </AdminNonAuthRoute>
                        }
                      />
                    ))}

                    {/*  ADMIN + STAFF PROTECTED */}
                    {adminRoutes.map((r, i) => (
                      <Route
                        key={i}
                        path={r.path}
                        element={
                          <AdminProtectedRoute permission={r.permission}>
                            <GetAdminLayout>{r.component}</GetAdminLayout>
                          </AdminProtectedRoute>
                        }
                      />
                    ))}

                    {staffRoutes.map((r, i) => (
                      <Route
                        key={i}
                        path={r.path}
                        element={
                          <AdminProtectedRoute>
                            <GetAdminLayout>{r.component}</GetAdminLayout>
                          </AdminProtectedRoute>
                        }
                      />
                    ))}
                  </Routes>
                </PackageBookingProvider>
                <GlobalToaster />
              </CartProvider>
            </NotificationProvider>
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
